import { render, staticRenderFns } from "./DateEmptyPlaceholder.vue?vue&type=template&id=09335cd8&"
import script from "./DateEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DateEmptyPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./DateEmptyPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports